import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type ChangedProductVariantStocks as SchemaChangedProductVariantStocks } from '../schemas/ChangedProductVariantStocks';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Обновляет остатки только для переданных складов. Остатки отсутствующих в запросе складов не изменяются.
Нулевое значение total_quantity явно обнуляет остаток, а reserved_quantity не изменяется.
Если записи об остатке для склада ещё нет, нулевое значение не создаёт её.
Если один склад передан несколько раз, применяется последнее значение. Пустой список не изменяет данные.

 * @tags Products
 * @summary Частично обновить остатки варианта товара
 */
export const UpdateProductVariantStocksContentType = 'application/json' as const;
export type UpdateProductVariantStocksRequest = SchemaChangedProductVariantStocks;
export type UpdateProductVariantStocksResponses = LinkCommonErrorResponses & {};
export type UpdateProductVariantStocksResponseSuccess = undefined;
export type UpdateProductVariantStocksSearchParams = undefined;
export type UpdateProductVariantStocksPathParameters = {
    product_variant_id: string;
};
export const UpdateProductVariantStocksUrl = '/variants/{product_variant_id}/stocks' as const;
export const UpdateProductVariantStocksMethod = 'PATCH' as const;
export const getUpdateProductVariantStocksUrl = (params: UpdateProductVariantStocksPathParameters) =>
    UpdateProductVariantStocksUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateProductVariantStocksPathParameters) => String(params[param])
    );
